import React, { useRef, useEffect } from 'react'
import Heading from '../Typography/Heading'
import SpecialText from '../Typography/SpecialText'
import gsap from 'gsap'
import {
  publicMainHeaderOffsetClass,
  PUBLIC_FORM_FIELD_GAP_CLASS,
} from '../../../sections/Public/shared/publicLayoutSpec'

const CustomerSupportBanner = ({
  heading,
  className,
  children,
  headingClasses,
  contentOffsetClassName = publicMainHeaderOffsetClass(),
}) => {
  const titleWrapperRef = useRef(null);
  const subtitleWrapperRef = useRef(null);

  useEffect(() => {
    const elements = [titleWrapperRef.current, subtitleWrapperRef.current].filter(Boolean);
    gsap.set(elements, { opacity: 0, y: 60 });
    gsap.to(elements, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.15,
    });
  }, []);

  return (
    <>
      <div className={`${className} w-[100%] h-screen sm:h-[120vh] lg:h-[130vh] relative bg-no-repeat bg-center object-cover bg-cover`}>
        <div className={`mx-[5%] xl:mx-auto xl:w-[1100px] 2xl:w-[1264px] h-full ${contentOffsetClassName} text-center sm:text-center flex flex-col items-center justify-center`}>
          <div ref={titleWrapperRef}>
            <Heading variant={"h1"} className={`${headingClasses}`}>
              {heading}
            </Heading>
          </div>
          <div ref={subtitleWrapperRef}>
            <SpecialText variant={"IntroParagraph"} className={`text-white !capitalize ${PUBLIC_FORM_FIELD_GAP_CLASS} max-w-3xl mx-auto`}>
              No gig workers. Just local trades you can contact directly and deal with on your terms.
            </SpecialText>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export default CustomerSupportBanner 